import App from '@/App';
import { PATHS } from '@/router/paths';
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate, createBrowserRouter } from 'react-router-dom';

// Lazy load all pages for better performance
const HomePage = lazy(() => import('@/pages/home/HomePage'));
const FloorGuidePage = lazy(() => import('@/pages/floor-guide/FloorGuidePage'));
const ShopPage = lazy(() => import('@/pages/shop/ShopPage'));
const FNBPage = lazy(() => import('@/pages/fnb/FNBPage'));
const EventPage = lazy(() => import('@/pages/event/EventPage'));
const ParkingPage = lazy(() => import('@/pages/parking/ParkingPage'));
const FacilityPage = lazy(() => import('@/pages/facility/FacilityPage'));
const FAQPage = lazy(() => import('@/pages/faq/FAQPage'));
const TourGuidePage = lazy(() => import('@/pages/tour-guide/TourGuidePage'));

const routes: RouteObject[] = [
    {
        element: <App />,
        children: [
            {
                path: PATHS.INDEX,
                children: [
                    { index: true, element: <Navigate to={PATHS.HOME.INDEX} replace /> },
                    {
                        path: PATHS.HOME.INDEX,
                        children: [{ index: true, element: <HomePage />, handle: { fullWidth: true } }],
                    },
                    {
                        path: PATHS.FLOOR_GUIDE.INDEX,
                        children: [{ index: true, element: <FloorGuidePage /> }],
                    },
                    {
                        path: PATHS.SHOP.INDEX,
                        children: [{ index: true, element: <ShopPage /> }],
                    },
                    {
                        path: PATHS.FNB.INDEX,
                        children: [{ index: true, element: <FNBPage /> }],
                    },
                    {
                        path: PATHS.EVENTS.INDEX,
                        children: [{ index: true, element: <EventPage /> }],
                    },
                    {
                        path: PATHS.PARKING.INDEX,
                        children: [{ index: true, element: <ParkingPage /> }],
                    },
                    {
                        path: PATHS.FACILITY.INDEX,
                        children: [{ index: true, element: <FacilityPage /> }],
                    },
                    {
                        path: PATHS.FAQ.INDEX,
                        children: [{ index: true, element: <FAQPage /> }],
                    },
                    {
                        path: PATHS.TOUR_GUIDE.INDEX,
                        children: [{ index: true, element: <TourGuidePage /> }],
                    },
                ],
            },
            { path: '*', element: <Navigate to={PATHS.HOME.INDEX} replace /> },
        ],
    },
];

export const router = createBrowserRouter(routes);
export default routes;
